import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '@shared/services/base.service';
import { Observable, map } from 'rxjs';

import { MoneyInOutListSearchCriteria } from '../models/money-in-out-list.model';

@Injectable({
  providedIn: 'root'
})
export class MoneyInOutService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.moneyInOut;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  public list(criteria: MoneyInOutListSearchCriteria): Observable<any> {
    const storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.list, {
      storeNo
    });
    const params = this.getParams(criteria, true);

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(null),
        observe: 'body',
        params
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  public detail(docNo): Observable<any> {
    const storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.detail, {
      storeNo
    });

    const request = { documentNo: docNo };
    return this.http.post<any>(url, request, {
      headers: this.loaderHeaders(),
      observe: 'body',
      responseType: 'json'
    });
  }
}
